module.exports = __webpack_public_path__ + "static/img/3_right_1.a1c35258.png";